import { TaskAutomationStatStrip } from './TaskAutomationStatStrip';
import { TasksQueueToolbar } from './TasksQueueToolbar';
import { TaskQueueView } from './TaskQueueView';
import { useTasksQueuePage } from './useTasksQueuePage';

/** Company task queue — the URL-parameterized `/tasks` route. */
export function TasksQueuePage() {
  const page = useTasksQueuePage();

  return (
    <TaskQueueView
      queue={page}
      toolbar={
        <>
          <TasksQueueToolbar
            total={page.total}
            searchInput={page.searchInput}
            onSearchInputChange={page.setSearchInput}
            searchParams={page.searchParams}
            updateSearchParams={page.updateSearchParams}
            taskTypes={page.taskTypes}
            selectedTypeId={page.selectedType?.id}
            users={page.assigneePickerUsers}
            agents={page.assigneePickerAgents}
            configuredColumns={page.configuredColumns}
            onToggleColumn={(id, hidden) => page.updateColumn(id, { hidden })}
            onResetColumns={page.resetToDefaults}
          />
          {page.selectedType && (
            <TaskAutomationStatStrip taskTypeKey={page.selectedType.key} />
          )}
        </>
      }
    />
  );
}
